export const SET_SIDEBAR = 'SET_SIDEBAR';